import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';
import ErrorBaseLayout from '@/pages/Errors/errorBaseLayout.tsx';
import {useAuthUtils} from "@/hooks/useAuthUtils.ts";

export default function UnexpectedError() {
  const { t } = useTranslation();
  const {authRedirect} = useAuthUtils();
  return (
    <ErrorBaseLayout>
      <h1 className="text-4xl font-bold">
        {t('Error.Attention')}
      </h1>

      <div className="mt-[30px] flex flex-col gap-8 text-lg">
        <p className="font-bold">{t('Error.ErrorMessage')}</p>
        <div className="flex">
          <Button
            variant="default"
            onClick={() => authRedirect()}
          >
            {t('Error.ReturnToDashboard')}
          </Button>
        </div>
      </div>
      </ErrorBaseLayout>
  );
}
